export const useStyles = theme => ({
    tierTitle: {
        font: 'normal normal 900 40px Maax-Black',
        color: '#fff',
        textAlign: 'center'
    },
    nameButton: {
        color: '#fff',
        width: '100%',
        height: '40px',
        borderColor: '#fff',
        borderRadius: '10px',
        '&:hover': {
          backgroundColor: '#fff',
          color: '#0D6A41'
        },
        [theme.breakpoints.down('md')]: {
           height: '80px',
        },
    },
    selectedButton: {
        color: '#0D6A41',
        backgroundColor: '#fff',
        width: '100%',
        height: '40px',
        borderColor: '#fff',
        borderRadius: '10px',
        '&:hover': {
            backgroundColor: '#0D6A41',
            color: '#fff'
        },
        [theme.breakpoints.down('md')]: {
            height: '80px',
        },
    },
    leftArrow: {
        float: 'left',
        color: '#fff'
    },
    rightArrow: {
        float: 'right',
        color: '#fff'
    },
    pageArrow: {
        color: '#fff',
        float: 'right',
    },
    pageNum: {
        color: '#fff',
        float: 'right',
        width: '50px',
        textAlign: 'center'
    },
    disabled: {
        color: '#0D6A41'
    },
})